import { z } from "zod";
import { artifactHashSchema, CANONICAL_SCHEMA_VERSION } from "./artifacts";

export const approvalGateSchema = z.enum([
  "brief",
  "storyline",
  "visual_direction",
]);

const approvalBaseSchema = z.object({
  schemaVersion: z.literal(CANONICAL_SCHEMA_VERSION),
  approvalId: z.string().trim().min(1).max(200),
  gate: approvalGateSchema,
  artifactHash: artifactHashSchema,
  artifactRevision: z.number().int().positive(),
  actorId: z.string().trim().min(1).max(200),
  createdAt: z.string().datetime({ offset: true }),
});

export const approvalRecordSchema = z.discriminatedUnion("status", [
  approvalBaseSchema
    .extend({
      status: z.literal("approved"),
    })
    .strict(),
  approvalBaseSchema
    .extend({
      status: z.literal("changes_requested"),
      reason: z.string().trim().min(1),
    })
    .strict(),
]);

export type ApprovalGate = z.infer<typeof approvalGateSchema>;
export type ApprovalRecord = z.infer<typeof approvalRecordSchema>;
